import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breaddcrumbs',
  templateUrl: './breaddcrumbs.component.html'
})
export class BreaddcrumbsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
